import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetCommentsInput } from '../domain/dtos/get-comments-input'
import { GetCommentsResponse } from '../domain/dtos/get-comments-response'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetComments {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient<GetCommentsResponse>,
  ) {}

  public async execute(input: GetCommentsInput): Promise<GetCommentsResponse | undefined> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_MEMBERS_AREA_URL}/hub/posts/${input.postId}/comments`,
      params: {
        page: input.page,
        pageSize: input?.pageSize,
        orderBy: 'createdAt',
        orderDir: input.orderDir,
      },
    })

    if (response.statusCode === HttpStatusCode.CREATED || response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    throw new GeneralError()
  }
}
